<template>
  <div class="services-showcase-area ptb-100">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Nossos Serviços</span>
        <h2>Fábrica de Software e Desenvolvimento de Projetos</h2>
        <p>Do discovery à entrega, construímos sistemas, ERPs e apps sob medida para o seu negócio</p>
      </div>

      <!-- Primeira Seção -->
      <div class="service-section" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="service-visual">
              <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                   alt="Desenvolvimento de Software">
              <div class="visual-overlay">
                <div class="overlay-stat">
                  <i class="ph-factory"></i>
                  <span>Fábrica de Software</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="service-content">
              <div class="content-badge">
                <i class="ph-factory"></i>
                <span>Fábrica de Software</span>
              </div>
              <h3>Desenvolvimento de Projetos sob Medida</h3>
              <p>Atuamos como fábrica de software: levantamos requisitos, arquitetamos e entregamos sistemas web, mobile e ERPs alinhados ao seu processo.</p>

              <div class="service-features">
                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-code"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Sistemas Web & Portais</h4>
                    <p>Aplicações corporativas, dashboards e portais B2B/B2C com arquitetura escalável</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-device-mobile"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Apps Mobile (iOS/Android)</h4>
                    <p>Aplicativos nativos e híbridos integrados aos seus sistemas</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-chart-line"></i>
                  </div>
                  <div class="feature-text">
                    <h4>ERP & Sistemas de Gestão</h4>
                    <p>ERPs completos, CRM e verticais sob medida para o seu segmento</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-plugs-connected"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Integrações & APIs</h4>
                    <p>Conectamos sistemas, pagamentos, fiscal e automações do dia a dia</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Segunda Seção -->
      <div class="service-section reverse" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12 order-lg-2">
            <div class="service-visual">
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80"
                   alt="Consultoria e Suporte">
              <div class="visual-overlay">
                <div class="overlay-stat">
                  <i class="ph-headset"></i>
                  <span>Suporte 24/7</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 order-lg-1">
            <div class="service-content">
              <div class="content-badge">
                <i class="ph-users-three"></i>
                <span>Consultoria Especializada</span>
              </div>
              <h3>Acompanhamento Completo do Projeto</h3>
              <p>Do planejamento ao suporte pós-entrega, nossa equipe está sempre ao seu lado para garantir o sucesso do projeto.</p>

              <div class="service-features">
                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-clipboard-text"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Análise de Requisitos</h4>
                    <p>Levantamento detalhado de necessidades e definição de escopo</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-tree-structure"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Arquitetura de Software</h4>
                    <p>Estrutura escalável, segura e otimizada para performance</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-wrench"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Manutenção & Suporte</h4>
                    <p>Atualizações constantes e suporte técnico especializado 24/7</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="ph-cloud"></i>
                  </div>
                  <div class="feature-text">
                    <h4>Hospedagem & Infraestrutura</h4>
                    <p>Servidores otimizados com monitoramento e backups automáticos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA Final -->
      <div class="services-cta" data-aos="fade-up">
        <div class="cta-content">
          <h3>Pronto para transformar sua ideia em realidade?</h3>
          <p>Fale com nossos especialistas e descubra como podemos ajudar seu negócio a crescer</p>
          <a href="https://wa.me/5554992302401?text=Olá! Quero saber mais sobre os serviços da Fontes Business"
             target="_blank"
             class="btn-style-one green-color"
             rel="noopener noreferrer">
            Falar com Especialista
            <i class="ph-caret-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services'
}
</script>

<style scoped>
/* ===== AREA BASE ===== */
.services-showcase-area {
  background: linear-gradient(180deg, #f9f9f9 0%, #ffffff 50%, #f9f9f9 100%);
}

/* ===== SERVICE SECTION ===== */
.service-section {
  margin-bottom: 100px;
  position: relative;
}

.service-section:last-of-type {
  margin-bottom: 80px;
}

/* ===== VISUAL ===== */
.service-visual {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
}

.service-visual img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.service-visual:hover img {
  transform: scale(1.05);
}

.visual-overlay {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 30px;
}

.overlay-stat {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 15px 25px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.overlay-stat i {
  font-size: 28px;
  color: #6D5DFC;
}

.overlay-stat span {
  font-weight: 700;
  color: #1a1a1a;
  font-size: 16px;
}

/* ===== CONTENT ===== */
.service-content {
  padding-left: 40px;
}

.service-section.reverse .service-content {
  padding-left: 0;
  padding-right: 40px;
}

.content-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(109, 93, 252, 0.1);
  border: 1px solid rgba(109, 93, 252, 0.3);
  padding: 8px 18px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #6D5DFC;
}

.content-badge i {
  font-size: 18px;
}

.service-content h3 {
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
  line-height: 1.3;
}

.service-content > p {
  font-size: 16px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 35px;
}

/* ===== SERVICE FEATURES ===== */
.service-features {
  display: grid;
  gap: 25px;
}

.feature-item {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  padding: 20px;
  background: white;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.feature-item:hover {
  border-color: #6D5DFC;
  transform: translateX(10px);
  box-shadow: 0 8px 25px rgba(109, 93, 252, 0.15);
}

.feature-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.feature-item:hover .feature-icon {
  transform: rotate(5deg) scale(1.1);
}

.feature-icon i {
  font-size: 26px;
  color: white;
}

.feature-text h4 {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 8px;
}

.feature-text p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

/* ===== CTA FINAL ===== */
.services-cta {
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  padding: 60px 50px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 15px 50px rgba(109, 93, 252, 0.3);
}

.cta-content h3 {
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin-bottom: 15px;
}

.cta-content p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 30px;
}

.btn-style-one {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 15px 35px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.btn-style-one:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
  color: white;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .service-content,
  .service-section.reverse .service-content {
    padding: 0;
    margin-top: 40px;
  }

  .service-content h3 {
    font-size: 28px;
  }

  .service-visual img {
    height: 400px;
  }

  .service-section {
    margin-bottom: 60px;
  }

  .services-cta {
    padding: 40px 30px;
  }

  .cta-content h3 {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .service-visual img {
    height: 300px;
  }

  .overlay-stat {
    padding: 12px 20px;
  }

  .overlay-stat i {
    font-size: 22px;
  }

  .overlay-stat span {
    font-size: 14px;
  }

  .feature-item {
    padding: 15px;
  }

  .feature-item:hover {
    transform: translateX(5px);
  }
}
</style>